function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9,15.67A12,12,0,1,0,8.56,25L5.66,28.7l1.18.93,2.95-3.74a11.82,11.82,0,0,0,12.38,0l3,3.78,1.18-.93L23.41,25A11.93,11.93,0,0,0,27.9,15.67ZM16,26.12A10.45,10.45,0,1,1,26.4,15.67,10.46,10.46,0,0,1,16,26.12Zm.75-10.85L20.87,18,20,19.29l-4.5-3a.76.76,0,0,1-.33-.62V9h1.5ZM28.79,9l-.53.74L27,8.83l.5-.7a3,3,0,0,0-.43-3.64,2.77,2.77,0,0,0-3.63-.41l-.69.5-.88-1.22.7-.5a4.27,4.27,0,0,1,5.59.6A4.52,4.52,0,0,1,28.79,9ZM5,8.83,3.74,9.7,3.24,9a4.53,4.53,0,0,1,.57-5.55,4.26,4.26,0,0,1,5.57-.6l.71.51L9.21,4.58l-.7-.5a2.76,2.76,0,0,0-3.61.4,3,3,0,0,0-.41,3.69Z",
  fill: "#33ba69"
});

var SvgPredictionIcon = function SvgPredictionIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPredictionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prediction_icon.53196a2a.svg";
export { ForwardRef as ReactComponent };